import { render, staticRenderFns } from "./screening.vue?vue&type=template&id=6183315c&"
import script from "./screening.vue?vue&type=script&lang=js&"
export * from "./screening.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports